import { t } from 'i18next'
import React from 'react'
import { Breadcrumb } from '../templates/breadcrumbs.mod'
import { PageHeader } from '../templates/pageHeader'
import { removeBoldsAndSplitsButLastSplit } from '../utils/helpers'
import { Page } from './state'

export const DrupalPageLayout = ({
  blocks,
  page,
  breadcrumbs,
  departments,
  countries
}: {
  blocks: JSX.Element
  page: Page
  breadcrumbs: Array<Breadcrumb>
  departments: string[]
  countries: string[]
}): JSX.Element => {
  const isCookiePage =
    page.node.path?.toLowerCase() == t('CookiesPlaceholder:LinkToCookies') ||
    page.node.path?.toLowerCase() == '/site-services/cookie-policy' ||
    page.node.path?.toLowerCase() == '/site-services/cookie-notice'

  const pageLanguage = document.querySelector('html').getAttribute('lang')
  const nodeLanguage = page.node.language

  const metatagTitle =
    page.node.metatag.find((item) =>
      item.attributes?.name == 'title' ||
      item.attributes?.name == 'twitter:title' ||
      item.attributes?.property == 'og:title'
    )?.attributes?.content
  window.document.title = removeBoldsAndSplitsButLastSplit(metatagTitle ?? page.node.label)

  return (
    <main id="a11y-main" className={`main main--${page.node.bundle}`}>
      <div className="main__inner">
        <article className="page">
          <div className="page__inner" lang={pageLanguage !== nodeLanguage ? nodeLanguage : null}>
            {PageHeader(departments, countries, breadcrumbs, page.node)}
            <div className="page__content">
              {
                // Make sure this is a cookie notice page based on the predefined url
                isCookiePage ? (
                  // This will load the cookie-policy from CookiePro
                  <div className="container container--s grid--block">
                    <div id="ot-sdk-cookie-policy"></div>
                    <button
                      id="ot-sdk-btn"
                      className="ot-sdk-show-settings"
                      onClick={() => Optanon.ToggleInfoDisplay()}
                      style={{ marginTop: 30 }}
                    >
                      {t('CookiesPlaceholder:CookieSettings')}
                    </button>
                  </div>
                ) : (
                  blocks
                )
              }
            </div>
          </div>
        </article>
      </div>
    </main>
  )
}
